import React from 'react'
import Profilecomp from '../../components/admin/profile'
export default function Profile() {
  return (
    <div>
       <Profilecomp/> 
    </div>
  )
}
